import * as React from 'react';
import { CreateTransactionProvider } from './contexts/CreateTransactionsContext';
import { MainDialog } from './components/CreateTransactionsMainDialog';
import { TransactionsContext, TransactionsContextValues } from '../../../contexts/TransactionsContext';


const SubmitModal = () => {
  const { openModal,
    handleCancelModal,
  } = React.useContext(TransactionsContext) as TransactionsContextValues;

  return (
    <CreateTransactionProvider openModal={openModal}
      onCancel={handleCancelModal}>
      <MainDialog></MainDialog>
    </CreateTransactionProvider>
  );
};
export default SubmitModal;